import {ModelFilter} from '@volkswagen-onehub/car-technical-details-bff';
import {InspectionData} from './inspector';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@volkswagen-onehub/components-core';
import React from 'react';

interface TabularDataRow {
  name: string;
  value: string;
}

export const HeaderInformation = (props: {
  inspectDataHolder: InspectionData;
}): React.JSX.Element => {
  const tabularData = createTabularData(props.inspectDataHolder);
  return (
    <>
      <h2>Model Selection</h2>
      <Table>
        <TableHead>
          <TableRow>
            <TableHeader>name</TableHeader>
            <TableHeader>value</TableHeader>
          </TableRow>
        </TableHead>
        <TableBody>
          {tabularData.map((t) => (
            <TableRow key={t.name}>
              <TableCell>{t.name}</TableCell>
              <TableCell>{t.value}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </>
  );
};

const createTabularData = (
  inspectDataHolder: InspectionData
): TabularDataRow[] => {
  const data: TabularDataRow[] = [];

  if (inspectDataHolder.showroomNodeIdFromService) {
    data.push({
      name: 'showroomNodeIdFromService',
      value: inspectDataHolder.showroomNodeIdFromService,
    });
  }
  if (inspectDataHolder.showroomNodeIdFromContent) {
    data.push({
      name: 'showroomNodeIdFromContent',
      value: inspectDataHolder.showroomNodeIdFromContent,
    });
  }

  displayModelContent(data, 'content', inspectDataHolder.modelsFromContent);
  displayModelContent(data, 'response', inspectDataHolder.modelsFromResponse);

  return data;
};

function displayModelContent(
  data: TabularDataRow[],
  name: string,
  models?: ModelFilter[]
) {
  models?.forEach((d, idx) => {
    data.push({
      name: idx + 1 + '. model from ' + name,
      value:
        d.carlineId + '/' + (d.salesgroupId ?? '') + '/' + (d.trimId ?? ''),
    });
  });
}
